import {DatePickerWidget} from "../widget/DatePickerWidget";
import {toMs, toFSDate} from "../../util/timeutils";
import {TaskDueIndicator} from "./TaskDueIndicator";
import {TaskDueType} from "../../api/Constants";

export const TaskDueWidget = ({due, onChange, props}) => {
    const dueDate = new Date(due);
    const dueDateString = toFSDate(dueDate);
    const now = new Date();
    const nowString = toFSDate(now);
    let alert = 0;

    if ((now - dueDate) >= toMs("1 day")) {
        // past due
        alert = TaskDueType.OverDue;
    } else if (dueDateString === nowString) {
        alert = TaskDueType.Today;
    } else if ((dueDate - now) <= toMs("2 days")) {
        alert = TaskDueType.Soon;
    }

    if (onChange) {
        let children = <div/>
        if (alert > 0) {
            children = <TaskDueIndicator alert={alert} />
        }
        return <DatePickerWidget date={due} onChange={onChange} placeholder={"due date"}>{children}</DatePickerWidget>
    } else {
        if (alert > 0) {
            return <div>{toFSDate(new Date(due))} <TaskDueIndicator alert={alert} /></div>
        }
        return toFSDate(new Date(due));
    }
}